"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var resolveColor = function resolveColor(_ref) {
  var removableColor = _ref.removable,
      selectedColor = _ref.selected,
      normalColor = _ref.normal;
  return function (_ref2) {
    var theme = _ref2.theme,
        selected = _ref2.selected,
        removable = _ref2.removable;
    if (removable && !selected) return theme.orbit[removableColor];
    if (selected) return theme.orbit[selectedColor];
    return theme.orbit[normalColor];
  };
};

var _default = resolveColor;
exports.default = _default;